<ion-grid class="max-w-1336 content-box">
	<ion-row>
		<ion-col class="box-8">
			<ion-card color="secondary" [routerLink]="['hide-profile']">
				<ion-card-header>
					<ion-card-title>hide-profile</ion-card-title>
				</ion-card-header>
			</ion-card>
		</ion-col>
		<ion-col class="box-8" [routerLink]="['update-password']">
			<ion-card color="secondary">
				<ion-card-header>
					<ion-card-title>update-password</ion-card-title>
				</ion-card-header>
			</ion-card>
		</ion-col>
		<ion-col class="box-8" [routerLink]="['assign-certificate']">
			<ion-card color="secondary">
				<ion-card-header>
					<ion-card-title>assign-certificate</ion-card-title>
				</ion-card-header>
			</ion-card>
		</ion-col>
		<ion-col class="box-8" [routerLink]="['assign-role']">
			<ion-card color="secondary">
				<ion-card-header>
					<ion-card-title>assign-role</ion-card-title>
				</ion-card-header>
			</ion-card>
		</ion-col>
	</ion-row>
</ion-grid>
